// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"600\" height=\"600\" viewBox=\"0 0 600 600\"> <path fill=\"#268bcc\" d=\"M0 0h600v600H0z\"/><path fill=\"#fff\" d=\"M0 0h600v300H0z\"/> </svg> ";
// Exports
module.exports = code;